export const forestmagic = [
	{
		"id": 1,
		"jump": "forest1",
		"title": "Forest Magic I",
		"pic": "../img/forest/forest-magic-1.jpg",
		"alt": "Forest Magic 1, Digital Art Series",
		"left": "imagewide",
		"right": "slim",
		"orientation": "work"
	},
	{
		"id": 2,
		"jump": "forest2",
		"title": "Forest Magic II",
		"pic": "../img/forest/forest-magic-2.jpg",
		"alt": "Forest Magic 2, Digital Art Series",
		"left": "imagewider",
		"right": "slimmer",
		"orientation": "landscape"
	},
	{
		"id": 3,
		"jump": "forest3",
		"title": "Forest Magic III",
		"pic": "../img/forest/forest-magic-3.jpg",
		"alt": "Forest Magic 3, Digital Art Series",
		"left": "image",
		"right": "reg",
		"orientation": "work"
	},
]